import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { InboundDeliveryResponse } from './common/inboundDeliveryResponse';
import { useInboundDeliveryStore } from '../stores/inboundDeliveryStore';
import type { DeliveryStatus } from 'shared/deliveries/domain/deliveryStatus';

export interface CreateInboundDelivery {
  name: string;
  note: string | null;
  status: DeliveryStatus;
  customer: string | null;
  customerReference: string | null;
  plannedStartUtc: string | null;
  plannedFinishUtc: string | null;
  rows: CreateInboundDeliveryRow[];
}

export interface CreateInboundDeliveryRow {
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  note: string | null;
}

export interface CreateInboundDeliveryResponse {
  ok: true;
  delivery: InboundDeliveryResponse;
}

export function useCreateInboundDeliveryApi() {
  const store = useInboundDeliveryStore();

  return useCreateEntityApi<CreateInboundDelivery, CreateInboundDeliveryResponse>({
    url: 'delivery/inbound',
    translate: (t) => t.inboundDelivery.actions.create,
    async processOk(response) {
      const json = (await response.json()) as InboundDeliveryResponse;
      store.add(json);
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
